import getTemplate from './bk-button-primary-template.js';
import { dispatchStartLoadingEvent } from 'Base/modules/bk/events/bk-loading-animation';
import './styles.scss';
import { t } from 'Base/modules/bk/component-property-providers/bk-translations';

class BkButtonPrimary extends HTMLElement {
    #buttonText;
    #buttonType = 'submit';
    #classes = '';
    #dataAttribute = '';

    constructor() {
        super();
    }

    static get observedAttributes() {
        return ['bk-text', 'bk-type', 'bk-class', 'bk-data'];
    }

    attributeChangedCallback(property, oldValue, newValue) {
        if (!BkButtonPrimary.observedAttributes.includes(property) || oldValue === newValue) {
            return;
        }

        switch (property) {
            case 'bk-text':
                this.#buttonText = newValue;
                this.#updateButtonText();
                break;
            case 'bk-type':
                this.#buttonType = 'button';
                this.#updateButtonType();
                break;
            case 'bk-class':
                this.#classes = newValue;
                break;
            case 'bk-data':
                this.#dataAttribute = newValue;
                break;
        }
    }

    #getButtonText() {
        if (this.#buttonText) {
            return this.#buttonText;
        }

        return t('global.ok');
    }

    #updateButtonText() {
        if (!this.querySelector('button')) {
            return;
        }
        this.querySelector('button').textContent = this.#buttonText;
    }

    #updateButtonType() {
        if (!this.querySelector('button')) {
            return;
        }
        this.querySelector('button').type = this.#buttonType;
    }

    connectedCallback() {
        const content = getTemplate(this.#getButtonText(), this.#buttonType, this.#classes, this.#dataAttribute).content.cloneNode(true);
        this.append(content);

        const form = this.closest('form');
        if (this.#buttonType === 'submit' && form === null) {
            throw new Error('missing form element');
        }

        form?.addEventListener('submit', (event) => {
            event.preventDefault();

            const submitButton = this.querySelector('[data-button-primary]');
            submitButton.setAttribute('disabled', 'disabled');
            dispatchStartLoadingEvent(this);

            const stopLoadingListener = () => {
                submitButton.removeAttribute('disabled');
                document.removeEventListener('bk-stop-loading', stopLoadingListener);
            };

            document.addEventListener('bk-stop-loading', stopLoadingListener);
        });

        // TODO: make component extend HtmlButtonElement to not always have to do this for native attributes?
        if (this.hasAttribute('disabled')) {
            this.querySelector('button').disabled = true;
        }
    }
}

export default BkButtonPrimary;
